export const lazienkaData = {
    order: 5,
    name: 'lazienka',
    title: 'Łazienka',
    iconSrc: 'pic_lazienka.svg',
    headlineText: 'Ekologia w łazience… Czy to w ogóle możliwe? Oczywiście!',
    mainText:
        'Według danych GUS, w ciągu roku zużywamy ok. 34 m3 wody na osobę w miastach i ok. 25 m3 wody na osobę na terenach wiejskich. Dla miast daje to średnią ok. 93 litrów przypadających na osobę w ciągu doby. Niestety również to, co znajduje się w składzie produktów do higieny często sieje ogromne spustoszenie zaraz po tym, gdy dostanie się do rur. Co możemy z tym zrobić?',
    mainVideoSrc: '',
    odpadySection: [
        {
            text:
                'Zamień produkty do higieny na ich ekologiczne odpowiedniki – bambusowa szczoteczka do zębów zamiast plastikowej, wielorazowe maszynki do golenia zamiast jednorazowych, a szampon oraz mydło w kostce zamiast w plastikowym opakowaniu.',
        },
        {
            text:
                'Większość chusteczek higienicznych nie jest eko! Na rynku dostępne są natomiast ich ekologiczne odpowiedniki. To samo dotyczy papieru toaletowego – szukaj tego, który pochodzi z recyklingu.',
        },
        {
            text:
                'Maksymalnie wykorzystuj kosmetyki. Opakowanie w formie tubki można przeciąć, a butelkę wypłukać i wykorzystać jej zawartość w 100%.',
        },
        {
            text:
                'Używaj kosmetyków zgodnie z zaleceniami producenta (np. nałożenie większej ilości odżywki wcale nie da lepszego efektu, a wręcz przeciwnie, może zmusić cię do ponownego umycia włosów).',
        },
        {
            text:
                'Niektóre kosmetyki, np. peeling do ciała, nie powinny zawierać drobinek wykonanych z plastiku. Wybierz produkty cukrowe lub inne, organicznego pochodzenia.',
        },
    ],
    klimatSection: [],
    energiaSection: [],
    powietrzeSection: [],
    wodaSection: [
        {
            text:
                'Zamiast kąpieli w wannie wybierz szybki prysznic, a podczas mycia zębów zakręć wodę w kranie.',
        },
        {
            text: '',
            picSrc: 'pics/pic-12.png',
            caption:
                'Do napełnienia wanny średniej wielkości potrzeba ok. 150 litrów wody, zaś średnio w czasie prysznica zużywa się 15 litrów wody na minutę!',
        },
        {
            text:
                'Stosuj naturalne kosmetyki i detergenty, które nie zanieczyszczają wody i środowiska. Wiele kosmetyków i detergentów możemy wykonać samodzielnie. Roztwór z amoniaku, soda oczyszczona i ocet, woda utleniona, a nawet zwykły alkohol to świetne, naturalne środki do wywabiania plam.',
        },
        {
            text: '',
            picSrc: 'pics/pic-13.png',
            caption:
                'Gdyby wyrazić dzienne zużycie wody w procentach, okazałoby się, że około 97% wody zużywamy na cele higieniczne, mycie i sprzątanie, ale tylko 3% na picie i przygotowywanie jedzenia!',
        },
    ],
    czyWieszSection: [
        {
            text: '...Polska wysycha?...',
            more:
                'Od połowy lat 90. nasz kraj zmaga się z suszami letnimi, ' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://noizz.pl/ekologia/czeka-nas-susza-byc-moze-najwieksza-od-50-lat-powodem-miedzy-innymi-brak-sniegu/0qfzhxj ">https://noizz.pl/ekologia/czeka-nas-susza-byc-moze-najwieksza-od-50-lat-powodem-miedzy-innymi-brak-sniegu/0qfzhxj</a>' +
                '<div class="embed-wrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/idOcJ48KfqA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>',
        },
        {
            text:
                '...na opakowaniach produktów wielu firm jest napisane, że są one przyjazne środowisku, ale nie zawsze ma to przełożenie na rzeczywistość?...',
            more:
                'Czytając skład możemy się dowiedzieć, że w produkcie znajdują się np. konserwanty, silikony, silne detergenty czy nawet mikroplastik.',
        },
        {
            text:
                '…mieszkańcy miasta Jastrzębie-Zdrój mają możliwość uzyskania dotacji na budowę przyłącza kanalizacji sanitarnej?...',
            more: 'Kwota do uzyskania to 1200 zł! Wnioski można składać do końca bieżącego roku.',
        },
    ],
};
